export const GET_ALL_JOB: string = "GET_ALL_JOB";
export const GET_APPLICATIONS_BY_JOB_ID: string = "GET_APPLICATIONS_BY_JOB_ID";
export const GET_PRESIGN_URL: string = "GET_PRESIGN_URL";
export const GET_ONE_ORG: string = "GET_ONE_ORG";
export const LOADING: string = "LOADING";
